"use client"

import { RenderConfig } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ServiceSidebar/RenderConfig"
import { t } from "@/languages/i18n"
import CKEditorWrapper from "@/lib/config/lib/CkeditorWrapper"
import { ServiceSidebarProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"

export const ServiceSidebar: ComponentConfig<ServiceSidebarProps> = {
  label: "Tamda Group | Service Sidebar",
  //@ts-ignore
  fields: {
    titleCategory: {
      label: "Title Category",
      type: "text",
    },
    category: {
      label: "Category",
      type: "array",
      arrayFields: {
        categoryName: {
          label: "Category Name",
          type: "text",
        },
        contentType: {
          label: "Content Type",
          type: "select",
          options: [
            { label: "CKEditor", value: "ckeditor" },
            { label: "Career", value: "career" },
            { label: "FAQs", value: "faqs" },
            { label: "Link", value: "link" },
          ],
        },
        faqs: {
          label: "Danh sách FAQs",
          type: "array",
          arrayFields: {
            question: {
              label: "Câu hỏi",
              type: "text",
            },
            answer: {
              label: "Câu trả lời",
              type: "custom",
              render: ({ value, onChange }) => {
                return <CKEditorWrapper value={value} onChange={onChange} />
              },
            },
          },
        },
        contentCkeditor: {
          label: "Content CKEditor",
          type: "custom",
          render: (props: any) => <CKEditorWrapper {...props} />,
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    titleCategory: t("Information & Employment"),
    category: [
      {
        categoryName: t("Privacy"),
        link: "#",
      },
      {
        categoryName: t("Contact"),
        link: "#",
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
